// components
import { OverlayPanel } from '@centria-ui-atoms/overlay-panel'
import { Globe } from 'react-bootstrap-icons'
import { MouseEvent, useMemo, useRef } from 'react'
import { useRouter } from 'next/router'

// i18n
import { useTranslation } from 'react-i18next'

// utils
import { formatLanguageByShortCode } from '@dr-keyword-commons/formatters'

// styles
import classes from './styles.module.scss'

// types
import type { OverlayPanel as PrOverlayPanel } from 'primereact/overlaypanel'

export const ChangeLanguage = () => {
  const { i18n, t } = useTranslation()
  const overlay = useRef<PrOverlayPanel>(null)
  const { replace, query, asPath, pathname } = useRouter()

  const handleShowOverlay = (e: MouseEvent<HTMLElement>) =>
    overlay.current?.toggle(e)

  const handleChangeLanguage = (language: string) =>
    replace({ pathname, query }, asPath, { locale: language })

  const languageToChange = useMemo(
    () => ['en', 'es'].find((lang) => lang !== i18n.language),
    [i18n.language]
  )

  return (
    <div className={classes.changeLanguage}>
      <p onClick={handleShowOverlay} className='m-0'>
        <Globe />{' '}
        {
          formatLanguageByShortCode(t)[
            i18n.languages.find((lang) => lang === i18n.language)
          ]
        }
      </p>
      <OverlayPanel closeIcon panelRef={overlay} className={classes.panel}>
        <div
          className={classes.panel_item}
          onClick={() => handleChangeLanguage(languageToChange)}>
          {formatLanguageByShortCode(t)[languageToChange]}
        </div>
      </OverlayPanel>
    </div>
  )
}
